"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typography = require("@vds/typography");
function getStyles(typescale, viewport, typeSize) {
  return TitleConfig[typescale][viewport][typeSize];
}

// Mapping line-height according to brand3.0 specs.
var TitleConfig = {
  VDS: {
    desktop: {
      "2XLarge": {
        fontSize: 64,
        lineHeight: 64,
        fontWeight: 700,
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      XLarge: {
        fontSize: 48,
        lineHeight: 48,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      // Used by DropdownSelectMarking size large viewport=desktop/tablet
      large: {
        fontSize: 32,
        lineHeight: 36,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      medium: {
        fontSize: 24,
        lineHeight: 24,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      // Used by DropdownSelectMarking size small viewport=desktop/tablet
      small: {
        fontSize: 20,
        lineHeight: 24,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      XSmall: {
        fontSize: 14,
        lineHeight: 16,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      }
    },
    mobile: {
      "2XLarge": {
        fontSize: 36,
        lineHeight: 36,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      XLarge: {
        fontSize: 32,
        lineHeight: 32,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      // Used by DropdownSelectMarking size large viewport=mobile
      large: {
        fontSize: 24,
        lineHeight: 28,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      medium: {
        fontSize: 20,
        lineHeight: 20,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      // Used by DropdownSelectMarking size small viewport=mobile
      small: {
        fontSize: 16,
        lineHeight: 20,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      },
      XSmall: {
        fontSize: 14,
        lineHeight: 16,
        fontWeight: "bold",
        fontFamily: _typography.Fonts.VerizonNHGeDS
      }
    }
  },
  getStyles: getStyles
};
var _default = exports["default"] = TitleConfig;


//////////////////
// WEBPACK FOOTER
// ./~/@vds/selects/dist/cjs/utils/TitleConfig.js
// module id = 403
// module chunks = 0